import { isNil, keyBy } from 'lodash';
import priceTagFieldTypes from '@enums/price-tag-field-types';

const isEmptyValue = value => isNil(value) || value === '';

const checks = [
    {
        rule: 'required',
        fails: (field, value) => field.required && isEmptyValue(value),
    },
    {
        rule: 'min',
        fails: (field, value) => !isNil(field.min) && !isEmptyValue(value) && value < field.min,
        params: field => ({ min: field.min }),
    },
    {
        rule: 'max',
        fails: (field, value) => !isNil(field.max) && !isEmptyValue(value) && value > field.max,
        params: field => ({ max: field.max }),
    },
    {
        rule: 'maxLength',
        fails: (field, value) =>
            !isNil(field.maxLength) && typeof value === 'string' && value.length > field.maxLength,
        params: field => ({ maxLength: field.maxLength }),
    },
    {
        rule: 'ascendingTiers',
        fails: (field, value, values) =>
            !!field.greaterThan &&
            !isEmptyValue(value) &&
            !isEmptyValue(values[field.greaterThan]) &&
            value <= values[field.greaterThan],
    },
];

/**
 * @returns {Object} first failing rule per field key, e.g. { price: { rule: 'required', params: {} } }
 */
export function validatePriceTagValues(fields, values) {
    return (fields || []).reduce((errors, field) => {
        if (field.type === priceTagFieldTypes.boolean) return errors;
        const value = values[field.key];
        const failed = checks.find(check => check.fails(field, value, values));
        if (failed) {
            errors[field.key] = {
                rule: failed.rule,
                params: failed.params ? failed.params(field) : {},
            };
        }
        return errors;
    }, {});
}

export const keyFields = fields => keyBy(fields || [], 'key');

export default { validatePriceTagValues, keyFields };
